import React from 'react';
import { Row, Col } from '@vds/grids';
import { Container } from '@adobe/cq-react-editable-components';

import { Button } from '@vds/buttons';
import { TitleLockup } from '@vds/type-lockups';

import MiniCart from '../../../common/MiniCart/redesign';
import { viewport, isMobile, isTablet, getUrlName, getFlowType } from '../../../common/Helpers/index';
import { getCartDetails } from '../../../../services/Cart/actions';
import { goToProcessStep } from '../../../../redirection';

import { Margin } from '../../../common/styles';
import { FWAContainer } from '../../../common/FWAContainer';
import { checkCartidAndLQResponse } from '../../../common/Helpers/commonLog';
import { getChannelId } from '../../../../services/HttpService';

import { paymentLabels } from './labels';

export default class DownPayment extends Container {
  constructor(props) {
    super(props);
    checkCartidAndLQResponse('creditDownPayment');
    this.handleLoad = this.handleLoad.bind(this);
  }

  onClickContinue = () => {
    goToProcessStep(this.props.currentView, this.props.history);
  };

  componentDidMount() {
    getCartDetails();
    window.addEventListener('load', this.handleLoad);
  }

  handleLoad = () => {
    const pageName = getUrlName(window.location.href);
    const markerValue = `${pageName}:ui:${getChannelId()}:${getFlowType()}:render`;

    if (window?.performance?.measure) {
      window.performance.measure(markerValue);
    }
  };

  componentWillUnmount() {
    window.removeEventListener('load', this.handleLoad);
  }

  render() {
    const type = viewport();

    const components = this.childComponents;
    const miniCartComponents = components.filter(
      (item) => item.key.indexOf('/miniCartDueToday') >= 0 || item.key.indexOf('/miniCartDueMonthly') >= 0,
    );
    const isVisible = this.props.cartDetails ? this.props.cartDetails.isCartVisible : '';
    const downPaymentAmt = this.props?.downPaymentResponse?.downpaymentRes?.serviceResponse?.context?.cartInfo?.downPaymentAmount || '';
    const creditAmt = `${(downPaymentAmt / 24).toFixed(2)}`;

    return (
      <FWAContainer topBufferAuto enableLiveSupport>
        <Row>
          <Col colSizes={{ mobile: 4, tablet: 11, desktop: 8 }}>
            <Margin bottom="20px" top="20px">
              <TitleLockup
                data={{
                  title: {
                    bold: false,
                    size: 'titleXLarge',
                    color: 'primary',
                    children: paymentLabels.heading.replace('$downPaymentAmt', `$${downPaymentAmt}`),
                  },
                  subtitle: {
                    size: 'bodyLarge',
                    color: 'primary',
                    children: paymentLabels.subHeading.replace('$creditAmt', `$${creditAmt}`),
                  },
                }}
              />
            </Margin>
          </Col>

          <Col
            colSizes={{ mobile: 4, tablet: 4, desktop: 4 }}
            className={isMobile() || isTablet() ? 'hideForMobile' : 'margin90 onlyTopMargin cartContainer'}
          >
            {window.innerWidth > '768' && type === 'desktop' && (
              <MiniCart
                miniCartComponents={miniCartComponents}
                showCartStatus={(iscartVisibleVal) => this.props.showCart(iscartVisibleVal)}
                iscartVisible={isVisible}
              />
            )}
            <Margin top={isMobile() || isTablet() ? '40px' : '20px'} bottom={isMobile() ? '40px' : ''}>
              <Button size="large" width={isMobile() || isTablet() ? '100%' : '383px'} onClick={() => this.onClickContinue()}>
                Continue
              </Button>
            </Margin>
          </Col>
        </Row>
      </FWAContainer>
    );
  }
}
